import axios from 'axios'
const api = axios
const store = {
    actions: {
        getAllCustomers : async ({}) => {
            try{
                const response = await api.get('/Customer')
                return response
            }catch(error ){
                return error.response
            }
        },
        CreateNewCustomer: async ({},data) => {
            return api.post('/Customer',data)
        },
        updateCustomer: async ({},data) => {
            return api.patch('/Customer/'+data.id, data.data)
        },
        deleteCustomer : async ({}, idCustomer) => {
            return api.delete('/Customer/'+idCustomer)
        }
    }
}   
export default store